import React from 'react';
import {Grid, Typography} from '@material-ui/core';

type EmployeeErrorsProps = {
  validationErrors: string[];
};
const EmployeeValidationErrorSection = ({validationErrors}: EmployeeErrorsProps) => {
  return (
    <>
      {validationErrors.map(error => (
        <Grid item xs={12} sm={6} md={4} key={error}>
          <Typography>{error}</Typography>
        </Grid>
      ))}
    </>
  );
};

export default EmployeeValidationErrorSection;
